import {Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {Sync} from '@client/sync'
import {Task} from '@extensions/task'

export const updateWhenTaskMovedToCol = (task: Hub): void => {
  setTimeout(() => {
    updateWhenTaskMovedToColBase(task)
  }, 0)
}

const updateWhenTaskMovedToColBase = (task: Hub): void => {
  const box = Sync.getCurrentSandbox()
  const column = box.getHub(task.location)
  if (!column?.location) {
    return
  }

  const board = box.getHub(column.location)
  if (!board?.data?.settings) {
    return
  }

  const canComplete =
    PermissionsChecker.checkComplete(task) ||
    (PermissionsChecker.shouldFallbackToOldCheckComplete(task) &&
      PermissionsChecker.oldCheckComplete(task))

  if (canComplete) {
    const data = board.data.settings.autoDoneTaskWhenMoveToCol
    if (data?.checked && data?.values?.length) {
      if (data.values.includes(task.location)) {
        Task.insertInGTD(
          task,
          'done',
          'update-when-task-moved-to-col -> canComplete'
        )
      }
    }
  }
}
